import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import ImageCard from "../../components/card/ImageCard";
import FormButton from "../../components/FormButton";
import { useNotify } from "../../helper/notify";
import { GetFullMediaPath, requireRules } from "../../helper/method";
import { statusShowMock, tokenMock } from "../../helper/mock";
import PreviewFile from "../../components/PreviewFile";
import { $api } from "../../helper";
import { useNavigate, useSearchParams } from "react-router";
import FormItemInputNumber from "../../components/form-item/form-item-input-number";
import VideoCard from "../../components/card/VideoCard";
import MediaPreview from "../../components/MediaPreview";

export default function AddSlider() {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const notify = useNotify();
  const [file_type, setFile_type] = useState("");
  const navigate = useNavigate();
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/slider-home/",
  );
  const update = $api.useMutation("put", "/site-api/v1/slider-home/");
  const detail = $api.useMutation("get", "/site-api/v1/slider-home-detail/");
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const [fileMobile, setFileMobile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const [video, setVideo] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const [poster, setPoster] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد اسلاید");
    if (searchParams.get("u_id")) {
      detail.mutate({
        params: {
          query: {
            slider_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (detail.data?.data) {
      if (detail?.data?.data.file_type === 1) {
        setFile([
          {
            file: undefined,
            fileUrl: GetFullMediaPath(detail.data.data.image ?? ""),
            id: detail.data.data.u_id,
          },
        ]);
        setFileMobile([
          {
            file: undefined,
            fileUrl: GetFullMediaPath(detail.data.data.mobile_image ?? ""),
            id: detail.data.data.u_id,
          },
        ]);
      } else {
        setVideo([
          {
            file: undefined,
            fileUrl: GetFullMediaPath(detail.data.data.image ?? ""),
            id: detail.data.data.u_id,
          },
        ]);
        setPoster([
          {
            file: undefined,
            fileUrl: GetFullMediaPath(detail.data.data.cover ?? ""),
            id: detail.data.data.u_id,
          },
        ]);
      }
      setFile_type(detail?.data?.data?.file_type.toString());
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  // useEffect(() => {
  //   setFile([]);
  //   setFileMobile([]);
  //   setVideo([]);
  //   setPoster([]);
  // }, [file_type]);

  const onFinish = (
    values: {
      link: string;
      status: string;
      display_order: string;
      file_type: string;
    },
    redirect = true,
  ) => {
    const formData = new FormData();
    formData.append("status", values.status);
    formData.append("display_order", values.display_order);
    formData.append("link", values.link);
    formData.append("file_type", values.file_type);
    if (searchParams.get("u_id")) {
      formData.append(
        "slider_u_id",
        searchParams.get("u_id")?.toString() ?? "",
      );
    }
    if (file_type === "1") {
      formData.append("image", file?.at(0)?.file ?? file?.at(0)?.fileUrl ?? "");
      formData.append(
        "mobile_image",
        fileMobile?.at(0)?.file ?? fileMobile?.at(0)?.fileUrl ?? "",
      );
    } else {
      formData.append(
        "image",
        video?.at(0)?.file ?? video?.at(0)?.fileUrl ?? "",
      );
      formData.append(
        "cover",
        poster?.at(0)?.file ?? poster?.at(0)?.fileUrl ?? "",
      );
    }

    if (!searchParams.get("u_id")) {
      mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/slider-page");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      update.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/slider-page");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به اسلاید"
        title="اطلاعات اصلی اسلاید"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"link"}
            rules={[
              { type: "url", message: "لینک معتبر وارد کن" },
              {
                required: true,
                message: "لینک",
              },
            ]}
            className="col-span-1"
            label="لینک"
            inputProps={{
              placeholder: "لطفا لینک خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("وضعیت")}
            name={"status"}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش محصول خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("نوع فایل")}
            name={"file_type"}
            label="نوع فایل"
            inputProps={{
              placeholder: "لطفا نوع فایل نمایش محصول خود را انتخاب کنید.",
              options: [
                {
                  label: "تصویر",
                  value: "1",
                },
                {
                  label: "ویدیو",
                  value: "2",
                },
              ],
              onChange: (e) => {
                setFile_type(e);
              },
            }}
          />
          <FormItemInputNumber
            className="col-span-1"
            rules={requireRules("ترتیب نمایش")}
            name={"display_order"}
            label="ترتیب نمایش"
            inputProps={{
              placeholder: "لطفا ترتیب نمایش محصول خود را انتخاب کنید.",
            }}
          />
        </div>
      </FormCard>
      {file_type === "1" ? (
        <FormCard
          subTitle="تصویر مربوط به نمایش کاربر در نسخه‌های مختلف"
          title="تصویر اسلاید"
        >
          <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
            <div className="col-span-1 flex h-fit flex-col gap-2">
              <ImageCard
                mobile
                file={file}
                setFile={setFile}
                id="image2-20"
                name="file_image"
                title="تصویر مربوط به دسکتاپ خود را آپلود کنید"
              />
              {file?.map((e, i) => (
                <div className="w-40 h-40">
                  <PreviewFile
                    id={e.id}
                    setFile={setFileMobile}
                    url={e.fileUrl}
                    key={"preview-mobile-categorysdf" + i}
                  />
                </div>
              ))}
            </div>
            <div className="col-span-1 flex h-fit flex-col gap-2">
              <ImageCard
                mobile
                file={fileMobile}
                setFile={setFileMobile}
                id="image2-asd2"
                name="mobile_images"
                title="تصویر مربوط به موبایل خود را آپلود کنید"
              />
              {fileMobile?.map((e, i) => (
                <div className="w-40 h-40">
                  <PreviewFile
                    id={e.id}
                    setFile={setFileMobile}
                    url={e.fileUrl}
                    key={"preview-mobile-categxzcory" + i}
                  />
                </div>
              ))}
            </div>
          </div>
        </FormCard>
      ) : (
        <FormCard
          subTitle="ویدیو مربوط به نمایش کاربر در نسخه‌های مختلف"
          title="ویدیو اسلاید"
        >
          <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
            <div className="col-span-1 flex h-fit flex-col gap-2">
              <VideoCard
                file={video}
                setFile={setVideo}
                id="image1-1"
                name="desktop_image"
                title="ویدیو خود را بارگداری کنید"
              />
              {video?.map((e, i) => (
                <div className="w-40 h-40">
                  <MediaPreview
                    id={e.id}
                    setFile={setVideo}
                    mediaUrl={e.fileUrl}
                    type="video"
                    key={"preview-category" + i}
                  />
                </div>
              ))}
            </div>
            <div className="col-span-1 flex h-fit flex-col gap-2">
              <ImageCard
                mobile
                file={poster}
                setFile={setPoster}
                id="image2-2dsf"
                name="mobile_image"
                title="کاور مربوط به ویدیو را بارگذاری کنید"
              />
              {poster?.map((e, i) => (
                <div className="w-40 h-40">
                  <PreviewFile
                    id={e.id}
                    setFile={setPoster}
                    url={e.fileUrl}
                    key={"preview-mobile-categorsdfy" + i}
                  />
                </div>
              ))}
            </div>
          </div>
        </FormCard>
      )}
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
